import React, { Fragment, useEffect } from "react";
import Loader from "./component/common/loader/loader";
import Header from "./component/common/header/header";
import Sidebar from "./component/common/sidebar/sidebar";
import Rightsidebar from "./component/common/sidebar/rightsidebar";
import Footer from "./component/common/footer/footer";
import ThemeCustomize from "./component/common/theme-customizer/themeCustomize";
import { ToastContainer } from "react-toastify";
import { Outlet, useLocation } from "react-router-dom";
import ConfigDB from "./data/customizer/config";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useSelector } from "react-redux";
import usePushNotifications from "./hooks/usePushNotifications";

const App = () => {
  const animation = localStorage.getItem("animation") || ConfigDB.data.router_animation || 'fade'
  const location = useLocation();
  const user = useSelector((state) => state.User);
  const { isSupported, isSubscribed, subscribe } = usePushNotifications();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Initialize push notifications when user logs in
  // Removed automatic subscription - users must manually subscribe


  return (
    <Fragment>
      {/* <Loader /> */}
      <div className="page-wrapper">
        <div className="page-body-wrapper">
          <Header />
          <Sidebar />
          <Rightsidebar />
          <div className="page-body">
            <TransitionGroup>
              <CSSTransition
                key={location.key}
                timeout={100}
                classNames={animation}
                unmountOnExit
              >
                <div>
                  <Outlet />
                </div>
              </CSSTransition>
            </TransitionGroup>
          </div>
          <Footer />
          <ThemeCustomize />
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default App;
